"use client";

import nextDynamic from "next/dynamic";
import type { HeroAgentSliderVariantProps } from "./HeroAgentSliderVariant";

const HeroAgentSliderVariant = nextDynamic(() => import("./HeroAgentSliderVariant"));

export default function HeroAgentSliderVariantWrapper(props: HeroAgentSliderVariantProps) {
  return <HeroAgentSliderVariant {...props} />;
}
